"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "sourceDeleted", {
  enumerable: true,
  get: function get() {
    return _sourceDeleted["default"];
  }
});
var _sourceDeleted = _interopRequireDefault(require("./sourceDeleted"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }